import moment from "moment";

export const FORMAT_DATE = (date) => {
  if (!date) return 'N/A';
  
  // If date is a number and appears to be in seconds (not milliseconds)
  // We check if it's less than 10 billion (valid until year 2286)
  if (typeof date === 'number' && date < 10000000000) {
    // Convert from seconds to milliseconds
    return moment.utc(date * 1000).local().format("DD-MM-YYYY");
  }
  
  return moment.utc(date).local().format("DD-MM-YYYY");
};
